"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectionImpl = void 0;
const utils_1 = require("../utils");
class InjectionImpl {
    constructor(medic) {
        this.formatDose = (dose, qts) => [null, undefined, ...utils_1.NEGATIVE_ARRAY, ...utils_1.NEGATIVE_FLOAT_ARRAY].includes(dose) || qts === null
            ? null
            : qts === undefined
                ? 3
                : qts;
        this.type = 'injection';
        this.date = null;
        this.heure = medic.heure ?? null;
        this.minute = medic.minute ?? null;
        this.name = medic.nom ?? null;
        this.quantity = medic.dose ?? null;
        this.ampoule_holder_identification = medic.lot ?? null;
        this.unit = medic.unite ? medic.unite : this.formatDose(medic.dose, medic.unit);
        this.comment = medic.commentaire;
    }
}
exports.InjectionImpl = InjectionImpl;
